import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import { Instagram, Twitter, Facebook } from "lucide-react";
import souqMadarMark from "@/assets/brand/souq-madar-mark.png";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer className="mt-24 bg-espresso text-white/80" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-10 h-10 rounded-2xl overflow-hidden shrink-0">
                            <img
                                src={souqMadarMark}
                                alt={t("appName")}
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <div className="text-white font-black text-xl">{t("appName")}</div>
                    </div>
                    <p className="text-sm text-white/60 max-w-md leading-relaxed">{t("aboutFooter")}</p>
                </div>
                <div>
                    <div className="text-white font-bold mb-4">{t("home")}</div>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/products" className="hover:text-white transition-colors">{t("products")}</Link></li>
                        <li><Link to="/stores" className="hover:text-white transition-colors">{t("stores")}</Link></li>
                        <li><Link to="/sell" className="hover:text-white transition-colors">{t("openStore")}</Link></li>
                    </ul>
                </div>
                <div>
                    <div className="text-white font-bold mb-4">{t("contactUs")}</div>
                    <div className="flex items-center gap-3">
                        <a href="#" aria-label="Instagram" className="p-2 rounded-full bg-white/5 hover:bg-terracotta transition-colors"><Instagram className="w-4 h-4" /></a>
                        <a href="#" aria-label="Twitter" className="p-2 rounded-full bg-white/5 hover:bg-terracotta transition-colors"><Twitter className="w-4 h-4" /></a>
                        <a href="#" aria-label="Facebook" className="p-2 rounded-full bg-white/5 hover:bg-terracotta transition-colors"><Facebook className="w-4 h-4" /></a>
                    </div>
                </div>
            </div>
            <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">
                © {new Date().getFullYear()} {t("appName")}. {t("allRights")}
            </div>
        </footer>
    );
}
